export default __webpack_public_path__ + "static/media/text-bubble-white.8d2d6c20.svg";